import { z } from 'zod'

import { Option } from '@/app/component/form/types'

const inviteRoleOptions: Option[] = [
  { value: 'manager', label: 'Manager' },
  { value: 'collaborator', label: 'Collaborator' },
  { value: 'cati_agent', label: 'CATI Agent' },
]

export const userInviteFields = {
  email: {
    fieldProps: {
      autoFocus: true,
      label: 'Email',
      name: 'email',
      required: true,
    },
    type: 'email',
  },
  firstName: {
    fieldProps: {
      label: 'First name',
      name: 'firstName',
    },
    type: 'text',
  },
  lastName: {
    fieldProps: {
      label: 'Last name',
      name: 'lastName',
    },
    type: 'text',
  },
  role: {
    fieldProps: {
      label: 'Role',
      name: 'role',
      options: inviteRoleOptions,
      required: true,
    },
    type: 'select',
  },
} as const

export const userInviteSchema = z.object({
  email: z
    .string({ required_error: 'Email is required' })
    .min(1, 'Email is required')
    .email('Please enter a valid email address'),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  role: z.enum(['manager', 'collaborator', 'cati_agent'], {
    message: 'Please select a role',
  }),
})

export type UserInviteFormValues = z.infer<typeof userInviteSchema>

export const userInviteDefaultValues: UserInviteFormValues = {
  email: '',
  firstName: '',
  lastName: '',
  role: undefined as any, // Empty default selection to force user to choose
}
